export default __webpack_public_path__ + "23a47a1292aca0d7df21a228f40655ec.gif";